import { Feature } from "ol";
import { GPX, KML } from "ol/format";
import { IFormat } from "../../Contexts/PrintContext";
import { blobToKmz } from "../Import/zipUtils";
import { LineString, Polygon } from "ol/geom";

const kmlFormat = new KML();
const gpxFormat = new GPX();

export const exportFeatures = async (format: IFormat, features: Feature[], fileName?: string): Promise<Blob> => {
    return format.value === "kml"
        ? exportFeaturesAsKML(features)
        : format.value === "gpx"
        ? exportFeaturesAsGPX(features)
        : await exportFeaturesAsKMZ(features, fileName);
};

const exportFeaturesAsKMZ = async (features, fileName) => {
    const kmlBlob = exportFeaturesAsKML(features);
    const zipBlob = await blobToKmz(kmlBlob, fileName);
    return zipBlob;
};

const exportFeaturesAsKML = (features) => {
    try {
        const kmlString = kmlFormat.writeFeatures(features, {
            dataProjection: "EPSG:4326",
            featureProjection: "EPSG:3059"
        });

        return new Blob([kmlString], { type: "application/vnd.google-earth.kml+xml" });
    } catch (error) {}
};

const exportFeaturesAsGPX = (features: Feature[]) => {
    // GPX supprts only point or line geometries.
    // Polygons can be exported as lines
    features.map((f) => {
        const geometry = f.getGeometry();
        (geometry.getType() === "Polygon" || geometry.getType() === "MultiPolygon") &&
            f.setGeometry(new LineString((geometry as Polygon).getLinearRing(0).getCoordinates()));
    });

    try {
        const gpxString = gpxFormat.writeFeatures(features, {
            dataProjection: "EPSG:4326",
            featureProjection: "EPSG:3059"
        });

        return new Blob([gpxString], { type: "application/gpx+xml" });
    } catch (error) {}
};
